import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import {  Redirect } from "react-router-dom";
import * as Yup from "yup";
import * as auth from "../_redux/authRedux";
import {emailChangePassword, resetPassword} from "../_redux/authCrud";
import {useTranslation} from "react-i18next";

const initialValues = {
  password: "",
  changepassword: "",
};

function EmailChangePassword({match}) {

  const {e,r} = match.params

  const [isRequested, setIsRequested] = useState(false);
  const { t } = useTranslation('common')
  const [okMessage, setOkMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const ForgotPasswordSchema = Yup.object().shape({
    password: Yup.string()
      .min(3, t('AtLeastCharacters'))
      .max(50, t('MaximumCharacters'))
      .required(
        t('AUTH.VALIDATION.REQUIRED_FIELD')
      ),
    changepassword: Yup.string()
      .required(
        t('AUTH.VALIDATION.REQUIRED_FIELD')
      )
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          t('SamePassword')
        ),
      }),
  });

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: ForgotPasswordSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      emailChangePassword(e,r,values.password)
        .then(({ data}) => {
          if (data.success) {
            setStatus('')
            setOkMessage(t('UpdateDone'))
            setTimeout(()=>{
              setIsRequested(true);
            },2000)
          } else {
            setSubmitting(false);
            setStatus(
              data.error
            );
          }
        })
        .catch(() => {
          setIsRequested(false);
          setSubmitting(false);
          setStatus(
            t('AUTH.EMAIL.NOT_FOUND')
          );
        }).finally(()=>{
        setLoading(false)
      });
    },
  });

  return (
    <>
      {isRequested && <Redirect to="/auth" />}
      {!isRequested && (
        <div className="login-form login-forgot" style={{ display: "block" }}>
          <div className="text-center mb-10 mb-lg-20">
            <h3 className="font-size-h1">{t('PasswordRecovery')}</h3>
            <div className="text-muted font-weight-bold">
              {t('EnterPassword')}
            </div>
          </div>
          <form
            onSubmit={formik.handleSubmit}
            className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
          >
            {okMessage ? (
              <div className="mb-10 alert alert-custom alert-light-success alert-dismissible">
                <div className="alert-text font-weight-bold">{okMessage}</div>
              </div>
            ) : null}
            {formik.status && (
              <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
                <div className="alert-text font-weight-bold">
                  {formik.status}
                </div>
              </div>
            )}
            {!okMessage && <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Password"
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "password"
                )}`}
                name="password"
                {...formik.getFieldProps("password")}
              />
              {formik.touched.password && formik.errors.password ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.password}</div>
                </div>
              ) : null}
            </div>}
            {!okMessage && <div className="form-group fv-plugins-icon-container">
              <input
                placeholder="Re-enter Password"
                type="password"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                  "changepassword"
                )}`}
                name="changepassword"
                {...formik.getFieldProps("changepassword")}
              />
              {formik.touched.changepassword && formik.errors.changepassword ? (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{formik.errors.changepassword}</div>
                </div>
              ) : null}
            </div>}
            {!okMessage && <div className="form-group d-flex flex-wrap flex-center">
              <button
                id="kt_login_forgot_submit"
                type="submit"
                className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
                disabled={formik.isSubmitting}
              >
                {t('PasswordRegister')}
              </button>
            </div>}
            {loading && <span className="ml-3 spinner"/>}
          </form>
        </div>
      )}
    </>
  );
}

export default connect(null, auth.actions)(EmailChangePassword)
